module.exports = __webpack_public_path__ + "filerobot/index.html";